// Same-origin account API. The Rust service lives behind nginx's /mp proxy, so
// session cookies never leave rift.rivi.us and no provider secret reaches this
// browser bundle.
const ROOT = '/mp/auth';

async function request(path, options = {}) {
  const response = await fetch(`${ROOT}${path}`, {
    credentials: 'same-origin',
    headers: { Accept: 'application/json', ...(options.body ? { 'Content-Type': 'application/json' } : {}) },
    ...options,
  });
  // A host that serves the bundle without the /mp proxy answers these calls with
  // the SPA's own index.html and a 200. Treat any non-JSON reply as the service
  // being absent instead of silently reporting an empty, successful account.
  const json = response.headers.get('content-type')?.includes('application/json');
  const body = json ? await response.json().catch(() => ({})) : null;
  if (!response.ok || !body) throw new Error(body?.error || 'Account service is unavailable.');
  return body;
}

export const accountMe = () => request('/me');
export const accountLogin = (username, password) =>
  request('/login', { method: 'POST', body: JSON.stringify({ username, password }) });
export const accountRegister = (username, password) =>
  request('/register', { method: 'POST', body: JSON.stringify({ username, password }) });
export const accountLogout = () => request('/logout', { method: 'POST' });

const PROGRESSION_ROOT = '/mp/progression';

async function progressionRequest(path, options = {}) {
  const response = await fetch(`${PROGRESSION_ROOT}${path}`, {
    credentials: 'same-origin',
    headers: { Accept: 'application/json', ...(options.body ? { 'Content-Type': 'application/json' } : {}) },
    ...options,
  });
  const json = response.headers.get('content-type')?.includes('application/json');
  const body = json ? await response.json().catch(() => ({})) : null;
  if (!response.ok || !body) throw new Error(body?.error || 'Progression service is unavailable.');
  return body;
}

/** Current account XP. Guests return `{ signedIn:false }` and keep local XP. */
export const accountProgression = () => progressionRequest('/me');

/** Persist one offline AI elimination for a signed-in account. */
export const awardOfflineFightXp = (headshot = false) =>
  progressionRequest('/fight', { method: 'POST', body: JSON.stringify({ headshot: !!headshot }) });

export function beginOAuth(provider) {
  location.assign(`${ROOT}/oauth/${encodeURIComponent(provider)}/start`);
}
